import React, { useEffect, useState } from "react";
import "../sections.css";
import { getTarjetasInicio } from "../../../../config/services/strapi/home";
import TextSkeleton from "../../../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../../../components/Skeleton/ImageSkeleton";

export default function Noticias() {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      try {
        const tarjetas = await getTarjetasInicio();
        const tarjetaNoticias = tarjetas.find(
          (t: any) => t.titulo === "NOTICIAS"
        );
        setData(tarjetaNoticias);
      } catch (error) {
        console.error("Error cargando Noticias desde Strapi:", error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  const imageUrl = data?.portada?.url || null;

  return (
    <section className="section noticias">
      <div className="section-inner">
        <div className="col-media">
          {loading ? (
            <ImageSkeleton className="h-full relative z-[99999] pointer-events-none" />
          ) : (
            <div
              className="media-cover"
              style={{
                backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
              }}
            />
          )}
          <a href="/noticias" className="full-link" aria-label="Ir a Noticias" />
        </div>

        <div className="col-text">
          {loading ? (
            <TextSkeleton className="relative z-[99999] pointer-events-none" />
          ) : (
            <h1>
              <span>
                {data?.Titulo || "NOTICIAS"}
              </span>
            </h1>
          )}
          <a href="/noticias" className="full-link" aria-label="Ir a Noticias" />
        </div>
      </div>
    </section>
  );
}